var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 420,
    viewBox: "0 0 1080 420",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.2.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 210)",
    id: "546fb807-4106-4fc5-bed9-b8889dab4dc4"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -210,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 420
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "f4740187-3025-49c3-8269-c0bd854df32e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.06 0 0 3.06 540 210)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 16.9 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-187.1, -52.4)",
    d: "M 170.1 73.5 L 170.1 65.8 L 192.1 38.4 L 172.6 38.4 L 172.6 31.299999999999997 L 203.2 31.299999999999997 L 203.2 37.9 L 180.29999999999998 66.4 L 204.1 66.4 L 204.1 73.5 C 204.1 73.5 170.1 73.5 170.1 73.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-224.6, -52.4)",
    d: "M 207.6 73.5 L 207.6 65.8 L 229.6 38.4 L 210.1 38.4 L 210.1 31.299999999999997 L 240.7 31.299999999999997 L 240.7 37.9 L 217.79999999999998 66.4 L 241.6 66.4 L 241.6 73.5 C 241.6 73.5 207.6 73.5 207.6 73.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -67.75 31.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-102.45, -88.1)",
    d: "M 97.1 90.4 L 99.69999999999999 90.10000000000001 C 99.89999999999999 91.00000000000001 100.19999999999999 91.60000000000001 100.6 92.00000000000001 C 101.1 92.40000000000002 101.69999999999999 92.60000000000001 102.5 92.60000000000001 C 103.4 92.60000000000001 104 92.4 104.4 92.10000000000001 C 104.80000000000001 91.7 105.10000000000001 91.30000000000001 105.10000000000001 90.80000000000001 C 105.10000000000001 90.50000000000001 105.00000000000001 90.20000000000002 104.80000000000001 90.00000000000001 C 104.60000000000001 89.80000000000001 104.30000000000001 89.60000000000001 103.80000000000001 89.40000000000002 C 103.50000000000001 89.30000000000003 102.80000000000001 89.10000000000002 101.70000000000002 88.80000000000003 C 100.30000000000001 88.40000000000002 99.30000000000001 88.00000000000003 98.70000000000002 87.50000000000003 C 98 86.9 97.6 86 97.6 85 C 97.6 84.3 97.8 83.7 98.19999999999999 83.1 C 98.6 82.5 99.1 82.1 99.79999999999998 81.8 C 100.49999999999999 81.5 101.39999999999998 81.3 102.39999999999998 81.3 C 103.99999999999997 81.3 105.29999999999998 81.7 106.09999999999998 82.39999999999999 C 106.89999999999998 83.1 107.39999999999998 84.1 107.39999999999998 85.3 L 104.69999999999997 85.39999999999999 C 104.59999999999998 84.69999999999999 104.29999999999997 84.19999999999999 103.99999999999997 83.89999999999999 C 103.59999999999997 83.6 103.09999999999997 83.49999999999999 102.29999999999997 83.49999999999999 C 101.49999999999997 83.49999999999999 100.89999999999996 83.69999999999999 100.49999999999997 83.99999999999999 C 100.19999999999997 84.19999999999999 100.09999999999997 84.49999999999999 100.09999999999997 84.79999999999998 C 100.09999999999997 85.09999999999998 100.19999999999996 85.39999999999998 100.49999999999997 85.59999999999998 C 100.79999999999997 85.89999999999998 101.59999999999997 86.19999999999997 102.89999999999998 86.49999999999999 C 104.19999999999997 86.79999999999998 105.09999999999998 87.09999999999998 105.79999999999998 87.39999999999999 C 106.39999999999998 87.69999999999999 106.89999999999998 88.19999999999999 107.29999999999998 88.69999999999999 C 107.59999999999998 89.29999999999998 107.79999999999998 89.99999999999999 107.79999999999998 90.79999999999998 C 107.79999999999998 91.59999999999998 107.59999999999998 92.29999999999998 107.19999999999999 92.89999999999998 C 106.79999999999998 93.59999999999998 106.19999999999999 93.99999999999997 105.39999999999999 94.39999999999998 C 104.6 94.69999999999997 103.69999999999999 94.89999999999998 102.49999999999999 94.89999999999998 C 100.79999999999998 94.89999999999998 99.59999999999998 94.49999999999997 98.69999999999999 93.69999999999997 C 97.8 93 97.3 91.9 97.1 90.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -52.75 31.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-117.45, -88.1)",
    d: "M 112.5 94.7 L 112.5 81.5 L 122.2 81.5 L 122.2 83.7 L 115.10000000000001 83.7 L 115.10000000000001 86.60000000000001 L 121.7 86.60000000000001 L 121.7 88.80000000000001 L 115.10000000000001 88.80000000000001 L 115.10000000000001 92.4 L 122.4 92.4 L 122.4 94.60000000000001 L 112.5 94.7 L 112.5 94.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -37.6 31.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-132.6, -88.1)",
    d: "M 127.3 94.7 L 127.3 81.5 L 130 81.5 L 130 86.7 L 135.2 86.7 L 135.2 81.5 L 137.89999999999998 81.5 L 137.89999999999998 94.6 L 135.2 94.6 L 135.2 88.89999999999999 L 130 88.89999999999999 L 130 94.6 L 127.3 94.7 L 127.3 94.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -22.15 31.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-148.05, -88.1)",
    d: "M 143.1 94.7 L 143.1 81.5 L 152.79999999999998 81.5 L 152.79999999999998 83.7 L 145.7 83.7 L 145.7 86.60000000000001 L 152.29999999999998 86.60000000000001 L 152.29999999999998 88.80000000000001 L 145.7 88.80000000000001 L 145.7 92.4 L 153 92.4 L 153 94.60000000000001 L 143.1 94.7 L 143.1 94.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.05 31.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-163.15, -88.1)",
    d: "M 157.9 94.7 L 157.9 81.5 L 160.5 81.5 L 165.9 90.3 L 165.9 81.5 L 168.4 81.5 L 168.4 94.6 L 165.70000000000002 94.6 L 160.4 86 L 160.4 94.6 L 157.9 94.7 L 157.9 94.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.55 31.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-188.75, -88.15)",
    d: "M 183.2 94.7 L 180.1 81.60000000000001 L 182.79999999999998 81.60000000000001 L 184.79999999999998 90.60000000000001 L 187.2 81.60000000000001 L 190.39999999999998 81.60000000000001 L 192.7 90.80000000000001 L 194.7 81.60000000000001 L 197.39999999999998 81.60000000000001 L 194.2 94.7 L 191.39999999999998 94.7 L 188.79999999999998 84.9 L 186.2 94.7 L 183.2 94.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 35.7 31.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-205.9, -88.15)",
    d: "M 212.5 94.7 L 209.6 94.7 L 208.5 91.7 L 203.2 91.7 L 202.1 94.7 L 199.29999999999998 94.7 L 204.39999999999998 81.60000000000001 L 207.2 81.60000000000001 L 212.5 94.7 z M 207.6 89.5 L 205.79999999999998 84.6 L 203.99999999999997 89.5 L 207.6 89.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 50.55 31.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-220.75, -88)",
    d: "M 215.5 90.4 L 218.1 90.10000000000001 C 218.29999999999998 91.00000000000001 218.6 91.60000000000001 219 92.00000000000001 C 219.5 92.40000000000002 220.1 92.60000000000001 220.9 92.60000000000001 C 221.8 92.60000000000001 222.4 92.4 222.8 92.10000000000001 C 223.20000000000002 91.7 223.4 91.30000000000001 223.4 90.80000000000001 C 223.4 90.50000000000001 223.3 90.20000000000002 223.1 90.00000000000001 C 222.89999999999998 89.80000000000001 222.6 89.60000000000001 222.1 89.40000000000002 C 221.79999999999998 89.30000000000003 221.1 89.10000000000002 220 88.80000000000003 C 218.6 88.40000000000002 217.6 88.00000000000003 217 87.50000000000003 C 216.2 86.80000000000003 215.8 85.90000000000003 215.8 84.90000000000003 C 215.8 84.20000000000003 216 83.60000000000004 216.4 83.00000000000003 C 216.8 82.40000000000003 217.3 82.00000000000003 218 81.70000000000003 C 218.7 81.40000000000003 219.6 81.20000000000003 220.6 81.20000000000003 C 222.2 81.20000000000003 223.5 81.60000000000004 224.29999999999998 82.30000000000003 C 225.1 83.00000000000003 225.6 84.00000000000003 225.6 85.20000000000003 L 222.9 85.30000000000003 C 222.8 84.60000000000002 222.5 84.10000000000002 222.20000000000002 83.80000000000003 C 221.8 83.50000000000003 221.3 83.40000000000002 220.50000000000003 83.40000000000002 C 219.70000000000002 83.40000000000002 219.10000000000002 83.60000000000002 218.70000000000002 83.90000000000002 C 218.4 84.10000000000002 218.3 84.40000000000002 218.3 84.70000000000002 C 218.3 85.00000000000001 218.4 85.30000000000001 218.70000000000002 85.50000000000001 C 219.00000000000003 85.80000000000001 219.8 86.10000000000001 221.10000000000002 86.40000000000002 C 222.40000000000003 86.70000000000002 223.3 87.00000000000001 224.00000000000003 87.30000000000003 C 224.60000000000002 87.60000000000002 225.10000000000002 88.10000000000002 225.50000000000003 88.60000000000002 C 225.80000000000004 89.20000000000002 226.00000000000003 89.90000000000002 226.00000000000003 90.70000000000002 C 226.00000000000003 91.50000000000001 225.80000000000004 92.20000000000002 225.40000000000003 92.80000000000001 C 225.00000000000003 93.50000000000001 224.40000000000003 93.9 223.60000000000002 94.30000000000001 C 222.8 94.60000000000001 221.90000000000003 94.80000000000001 220.70000000000002 94.80000000000001 C 219.00000000000003 94.80000000000001 217.8 94.4 216.9 93.60000000000001 C 216 92.80000000000001 215.7 91.9 215.5 90.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 73.7 31.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-243.9, -88.15)",
    d: "M 250.5 94.7 L 247.6 94.7 L 246.5 91.7 L 241.2 91.7 L 240.1 94.7 L 237.29999999999998 94.7 L 242.39999999999998 81.60000000000001 L 245.2 81.60000000000001 L 250.5 94.7 z M 245.7 89.5 L 243.89999999999998 84.6 L 242.09999999999997 89.5 L 245.7 89.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 89.8 31.65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-260, -88.05)",
    d: "M 254.6 81.5 L 259.9 81.5 C 260.9 81.5 261.7 81.5 262.2 81.6 C 262.7 81.69999999999999 263.2 81.89999999999999 263.59999999999997 82.1 C 263.99999999999994 82.39999999999999 264.29999999999995 82.69999999999999 264.59999999999997 83.19999999999999 C 264.9 83.69999999999999 264.99999999999994 84.19999999999999 264.99999999999994 84.69999999999999 C 264.99999999999994 85.29999999999998 264.79999999999995 85.89999999999999 264.49999999999994 86.39999999999999 C 264.19999999999993 86.89999999999999 263.69999999999993 87.3 263.09999999999997 87.6 C 263.9 87.8 264.49999999999994 88.19999999999999 264.9 88.8 C 265.29999999999995 89.39999999999999 265.5 90 265.5 90.8 C 265.5 91.39999999999999 265.4 92 265.1 92.5 C 264.8 93.1 264.40000000000003 93.5 264 93.9 C 263.5 94.2 262.9 94.4 262.2 94.5 C 261.8 94.5 260.7 94.6 259 94.6 L 254.5 94.6 L 254.5 81.5 z M 257.2 83.7 L 257.2 86.7 L 258.9 86.7 C 259.9 86.7 260.59999999999997 86.7 260.79999999999995 86.7 C 261.29999999999995 86.60000000000001 261.59999999999997 86.5 261.9 86.2 C 262.2 85.9 262.29999999999995 85.60000000000001 262.29999999999995 85.2 C 262.29999999999995 84.8 262.19999999999993 84.5 261.99999999999994 84.2 C 261.79999999999995 83.9 261.3999999999999 83.8 260.99999999999994 83.7 C 260.69999999999993 83.7 259.99999999999994 83.7 258.69999999999993 83.7 C 258.7 83.7 257.2 83.7 257.2 83.7 z M 257.2 88.9 L 257.2 92.4 L 259.7 92.4 C 260.7 92.4 261.3 92.4 261.5 92.30000000000001 C 261.9 92.20000000000002 262.2 92.10000000000001 262.5 91.80000000000001 C 262.7 91.50000000000001 262.9 91.20000000000002 262.9 90.70000000000002 C 262.9 90.30000000000001 262.79999999999995 90.00000000000001 262.59999999999997 89.70000000000002 C 262.4 89.40000000000002 262.09999999999997 89.20000000000002 261.79999999999995 89.10000000000002 C 261.4 89.00000000000003 260.69999999999993 88.90000000000002 259.4 88.90000000000002 L 257.2 88.9 L 257.2 88.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 105.55 31.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-275.75, -88)",
    d: "M 276.2 89.8 L 276.2 87.6 L 281.9 87.6 L 281.9 92.8 C 281.29999999999995 93.3 280.5 93.8 279.5 94.2 C 278.4 94.60000000000001 277.4 94.8 276.3 94.8 C 274.90000000000003 94.8 273.7 94.5 272.7 93.89999999999999 C 271.7 93.3 270.9 92.49999999999999 270.4 91.39999999999999 C 269.9 90.3 269.59999999999997 89.19999999999999 269.59999999999997 87.89999999999999 C 269.59999999999997 86.49999999999999 269.9 85.3 270.49999999999994 84.3 C 271.09999999999997 83.2 271.8999999999999 82.39999999999999 272.99999999999994 81.89999999999999 C 273.79999999999995 81.49999999999999 274.8999999999999 81.19999999999999 276.09999999999997 81.19999999999999 C 277.7 81.19999999999999 278.99999999999994 81.49999999999999 279.9 82.19999999999999 C 280.79999999999995 82.89999999999999 281.4 83.79999999999998 281.7 84.99999999999999 L 279.09999999999997 85.49999999999999 C 278.9 84.89999999999999 278.59999999999997 84.29999999999998 278.09999999999997 83.99999999999999 C 277.59999999999997 83.59999999999998 276.99999999999994 83.39999999999999 276.2 83.39999999999999 C 275 83.39999999999999 274.09999999999997 83.8 273.4 84.49999999999999 C 272.7 85.19999999999999 272.4 86.29999999999998 272.4 87.79999999999998 C 272.4 89.39999999999998 272.7 90.49999999999999 273.4 91.29999999999998 C 274.09999999999997 92.09999999999998 275 92.49999999999999 276.09999999999997 92.49999999999999 C 276.7 92.49999999999999 277.2 92.39999999999999 277.79999999999995 92.19999999999999 C 278.4 91.99999999999999 278.79999999999995 91.69999999999999 279.19999999999993 91.39999999999999 L 279.19999999999993 89.69999999999999 L 276.2 89.69999999999999 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.75 31.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-291.95, -88.1)",
    d: "M 287 94.7 L 287 81.5 L 296.7 81.5 L 296.7 83.7 L 289.59999999999997 83.7 L 289.59999999999997 86.60000000000001 L 296.2 86.60000000000001 L 296.2 88.80000000000001 L 289.59999999999997 88.80000000000001 L 289.59999999999997 92.4 L 296.9 92.4 L 296.9 94.60000000000001 L 287 94.7 L 287 94.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 136.8 31.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-307, -88.1)",
    d: "M 301.7 94.7 L 301.7 81.5 L 304.4 81.5 L 304.4 86.7 L 309.59999999999997 86.7 L 309.59999999999997 81.5 L 312.29999999999995 81.5 L 312.29999999999995 94.6 L 309.59999999999997 94.6 L 309.59999999999997 88.89999999999999 L 304.4 88.89999999999999 L 304.4 94.6 L 301.7 94.7 L 301.7 94.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 151.5 31.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-321.7, -88.15)",
    d: "M 320.4 94.7 L 320.4 83.8 L 316.5 83.8 L 316.5 81.6 L 326.9 81.6 L 326.9 83.8 L 323 83.8 L 323 94.7 L 320.4 94.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -57.7 -4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "18.7,-21.1 9.5,-21.1 0,-4.6 -9.5,-21.1 -18.7,-21.1 -4.6,3.3 -14.8,21.1 -5.7,21.1 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 140.2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-310.4, -52.4)",
    d: "M 310.4 38.1 C 318.29999999999995 38.1 324.7 44.5 324.7 52.400000000000006 C 324.7 60.300000000000004 318.3 66.7 310.4 66.7 C 302.49999999999994 66.7 296 60.3 296 52.4 C 296 44.5 302.5 38.1 310.4 38.1 M 310.4 30.6 C 298.29999999999995 30.6 288.59999999999997 40.400000000000006 288.59999999999997 52.400000000000006 C 288.59999999999997 64.5 298.4 74.2 310.4 74.2 C 322.5 74.2 332.2 64.4 332.2 52.400000000000006 C 332.2 40.3 322.4 30.6 310.4 30.6 L 310.4 30.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 92.6 -3.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-262.8, -52.5)",
    d: "M 259.1 48.8 L 259.1 56 L 276.70000000000005 56 C 275.1 62.2 269.50000000000006 66.8 262.80000000000007 66.8 C 254.90000000000006 66.8 248.50000000000006 60.4 248.50000000000006 52.5 C 248.50000000000006 44.6 254.90000000000006 38.2 262.80000000000007 38.2 C 268.1000000000001 38.2 272.70000000000005 41.1 275.20000000000005 45.400000000000006 L 283.40000000000003 45.400000000000006 C 280.40000000000003 36.800000000000004 272.3 30.700000000000006 262.8 30.700000000000006 C 250.70000000000002 30.700000000000006 241 40.50000000000001 241 52.50000000000001 C 241 64.5 250.8 74.30000000000001 262.8 74.30000000000001 C 274.8 74.30000000000001 284.6 64.50000000000001 284.6 52.500000000000014 C 284.6 51.30000000000001 284.5 50.100000000000016 284.3 48.90000000000001 L 259.1 48.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -22 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-148.2, -52.4)",
    d: "M 144.5 56 L 144.5 48.9 L 162.1 48.9 C 160.5 42.699999999999996 154.9 38.099999999999994 148.2 38.099999999999994 C 140.29999999999998 38.099999999999994 133.89999999999998 44.49999999999999 133.89999999999998 52.39999999999999 C 133.89999999999998 60.29999999999999 140.29999999999998 66.69999999999999 148.2 66.69999999999999 C 153.5 66.69999999999999 158.1 63.79999999999999 160.6 59.499999999999986 L 168.79999999999998 59.499999999999986 C 165.79999999999998 68.09999999999998 157.7 74.19999999999999 148.2 74.19999999999999 C 136.1 74.19999999999999 126.39999999999999 64.39999999999999 126.39999999999999 52.39999999999999 C 126.39999999999999 40.39999999999999 136.2 30.59999999999999 148.2 30.59999999999999 C 160.2 30.59999999999999 170 40.3 170 52.4 C 170 53.6 169.9 54.8 169.7 56 L 144.5 56 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.7 -0.35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(12,101,175)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-46.5, -56.05)",
    d: "M 79 73.4 L 75.4 73.4 L 75.4 84.2 L 59.800000000000004 75.10000000000001 C 55.900000000000006 77.10000000000001 51.400000000000006 78.30000000000001 46.60000000000001 78.30000000000001 C 30.70000000000001 78.30000000000001 17.800000000000008 65.4 17.800000000000008 49.40000000000001 C 17.800000000000008 33.40000000000001 30.70000000000001 20.500000000000014 46.60000000000001 20.500000000000014 C 62.30000000000001 20.500000000000014 75 33.100000000000016 75.30000000000001 48.80000000000001 L 75.30000000000001 48.80000000000001 L 83.80000000000001 48.80000000000001 C 83.70000000000002 28.30000000000001 67.10000000000001 11.70000000000001 46.500000000000014 11.70000000000001 C 25.900000000000013 11.70000000000001 9.200000000000017 28.40000000000001 9.200000000000017 49.00000000000001 C 9.200000000000017 69.60000000000001 25.900000000000016 86.30000000000001 46.500000000000014 86.30000000000001 C 50.600000000000016 86.30000000000001 54.600000000000016 85.60000000000001 58.30000000000001 84.4 L 83.80000000000001 100.4 L 83.80000000000001 73.4 L 79 73.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.6 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-46.6, -56.4)",
    d: "M 79 72.3 L 75.4 72.3 L 75.4 49.8 L 83.9 49.8 L 85 49.8 L 85 48.699999999999996 C 84.9 27.599999999999994 67.7 10.499999999999993 46.6 10.499999999999993 C 25.400000000000002 10.499999999999993 8.200000000000003 27.699999999999992 8.200000000000003 48.89999999999999 C 8.200000000000003 70.1 25.400000000000002 87.29999999999998 46.6 87.29999999999998 C 50.6 87.29999999999998 54.5 86.69999999999999 58.2 85.49999999999999 L 83.2 101.19999999999999 L 84.9 102.29999999999998 L 84.9 100.29999999999998 L 84.9 73.4 L 84.9 72.30000000000001 L 83.80000000000001 72.30000000000001 L 79 72.30000000000001 z M 83.9 100.3 L 58.400000000000006 84.3 C 54.7 85.5 50.7 86.2 46.60000000000001 86.2 C 26.000000000000007 86.2 9.300000000000011 69.5 9.300000000000011 48.900000000000006 C 9.300000000000011 28.300000000000004 26.00000000000001 11.600000000000009 46.60000000000001 11.600000000000009 C 67.10000000000001 11.600000000000009 83.80000000000001 28.20000000000001 83.9 48.70000000000001 L 75.4 48.70000000000001 L 75.4 48.70000000000001 C 75.10000000000001 33.000000000000014 62.300000000000004 20.40000000000001 46.7 20.40000000000001 C 30.800000000000004 20.40000000000001 17.900000000000002 33.30000000000001 17.900000000000002 49.30000000000001 C 17.900000000000002 65.30000000000001 30.800000000000004 78.20000000000002 46.7 78.20000000000002 C 51.400000000000006 78.20000000000002 55.900000000000006 77.00000000000001 59.900000000000006 75.00000000000001 L 75.5 84.10000000000001 L 75.5 73.4 L 79 73.4 L 83.9 73.4 L 83.9 100.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.8 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(175,202,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-46.4, -49.4)",
    d: "M 64.1 49.4 C 64.1 59.2 56.199999999999996 67.2 46.39999999999999 67.2 C 36.599999999999994 67.2 28.699999999999992 59.2 28.699999999999992 49.400000000000006 C 28.699999999999992 39.60000000000001 36.599999999999994 31.600000000000005 46.39999999999999 31.600000000000005 C 56.2 31.6 64.1 39.5 64.1 49.4 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.55f25a5ca2fe62cf31ae762109f08fff.svg";
export { ForwardRef as ReactComponent };